import React, { useEffect } from "react";

import styles from "./analyticsCard.module.scss";

interface AnalyticsCardProps {
  value: number;
  name: string;
}

const AnalyticsCard: React.FC<AnalyticsCardProps> = ({ value, name }) => {

  return (
    <div className={styles.container}>
      <span className={styles.value}>{value}</span>
      <span className={styles.name}>{name}</span>
    </div>
  );
};

export default AnalyticsCard;
